// Header and footer shared by the notes index and every note — the two
// callers that justify pulling these out of a page file.

import React from "react";
import type { Brand } from "../types";

export const wrap: React.CSSProperties = { maxWidth:1040, margin:"0 auto", padding:"0 24px", position:"relative" };
export const heading: React.CSSProperties = { fontFamily:"'Bebas Neue',cursive", color:"var(--text-strong)", letterSpacing:"0.02em" };
export const label: React.CSSProperties = { fontSize:11, color:"var(--text-faint)", letterSpacing:"0.14em", textTransform:"uppercase", fontWeight:700 };
const navLink: React.CSSProperties = { color:"var(--text-soft)", fontSize:12, fontWeight:700, letterSpacing:"0.08em", textDecoration:"none", textTransform:"uppercase" };

/** "2026-10-13" -> "13 October 2026". Read as UTC so no timezone moves the day. */
export function formatDate(iso: string | undefined): string {
  if (!iso) return "";
  const d = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-US", { year:"numeric", month:"long", day:"numeric", timeZone:"UTC" });
}

export function NotesShell({ brand, children }: { readonly brand: Brand; readonly children: React.ReactNode }): React.JSX.Element {
  return (
    <div style={{ minHeight:"100vh", background:"var(--bg)", color:"var(--text)" }}>
      <div style={{ position:"fixed", inset:0, backgroundImage:"linear-gradient(var(--surface-raised) 1px,transparent 1px),linear-gradient(90deg,var(--surface-raised) 1px,transparent 1px)", backgroundSize:"44px 44px", opacity:0.4, pointerEvents:"none" }} />

      <div style={{ ...wrap, display:"flex", justifyContent:"space-between", alignItems:"center", gap:16, flexWrap:"wrap", padding:"20px 24px" }}>
        <a href="/" style={{ display:"inline-flex", alignItems:"baseline", gap:10, textDecoration:"none" }}>
          <span style={{ ...heading, fontSize:30, color:brand.primary }}>{brand.name}</span>
          <span style={{ fontSize:12, color:"var(--text-faint)", letterSpacing:"0.08em", textTransform:"uppercase", fontWeight:700 }}>Vending back office</span>
        </a>
        <div style={{ display:"flex", alignItems:"center", gap:20, flexWrap:"wrap" }}>
          <a href="/notes" style={navLink}>Notes</a>
          <a href="/card-fees" style={navLink}>Fee calculator</a>
          <a href="/#diagnostic" style={navLink}>Talk to us</a>
        </div>
      </div>

      {children}

      <div style={{ position:"relative", borderTop:"1px solid var(--border-subtle)", padding:"22px 24px", textAlign:"center", fontSize:12, color:"var(--text-faint)" }}>
        {brand.copyright} &copy; {new Date().getFullYear()} &nbsp;·&nbsp;{" "}
        <a href={brand.phoneHref} style={{ color:"var(--text-muted)", textDecoration:"none" }}>{brand.phone}</a> &nbsp;·&nbsp;{" "}
        <a href={`mailto:${brand.contactEmail}`} style={{ color:"var(--text-muted)", textDecoration:"none" }}>{brand.contactEmail}</a>
        <div style={{ marginTop:8 }}>{brand.positioning}</div>
      </div>
    </div>
  );
}
